<template>
    <div>
        <modal
            v-if="user"
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            modal-classes="app-modal--invitation"
            title="Отправить приглашение партнеру"
            btn-save-title="Отправить"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label required">
                    Электронная почта партнера
                </label>
                <input
                    id="email"
                    v-model.trim="email"
                    type="text"
                    class="cabinet-form-group__input cabinet-form-group__input--big mw-100"
                    :class="{
                        error:
                            ($v.email.$dirty && $v.email.$invalid) ||
                            (errors.sendInvitation.email && !$v.email.$dirty)
                    }"
                />
                <div
                    v-if="$v.email.$dirty && $v.email.$invalid"
                    class="error-label"
                >
                    Введите корректный email
                </div>
                <div
                    v-if="errors.sendInvitation.email && !$v.email.$dirty"
                    class="error-label"
                >
                    {{ errors.sendInvitation.email[0] }}
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="to">Кому</label>
                <input
                    id="to"
                    v-model.trim="name"
                    type="text"
                    class="cabinet-form-group__input cabinet-form-group__input--big mw-100"
                    :class="{
                        error:
                            ($v.name.$dirty && $v.name.$invalid) ||
                            (errors.sendInvitation.name && !$v.name.$dirty)
                    }"
                />
                <div
                    v-if="$v.name.$dirty && $v.name.$invalid"
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
                <div
                    v-if="errors.sendInvitation.name && !$v.name.$dirty"
                    class="error-label"
                >
                    {{ errors.sendInvitation.name[0] }}
                </div>
            </div>
            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="message">
                    Сообщение
                </label>
                <textarea
                    id="message"
                    v-model.trim="message"
                    class="cabinet-form-group__textarea cabinet-form-group__textarea--big cabinet-form-group__textarea--resizable mw-100"
                    :class="{
                        error:
                            ($v.message.$dirty && $v.message.$invalid) ||
                            (errors.sendInvitation.message &&
                                !$v.message.$dirty)
                    }"
                ></textarea>
                <div
                    v-if="$v.message.$dirty && $v.message.$invalid"
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
                <div
                    v-if="errors.sendInvitation.message && !$v.message.$dirty"
                    class="error-label"
                >
                    {{ errors.sendInvitation.message[0] }}
                </div>
            </div>
            <p class="pt-2 text">
                Ваш партнер получит на указанный адрес приглашение
                зарегистрироваться на площадке.
            </p>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapState, mapGetters, mapActions } from 'vuex'

import { required, email } from 'vuelidate/lib/validators'

const validations = {
    email: { required, email },
    name: {},
    message: {}
}

export default {
    name: 'InviteModal',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            email: '',
            name: '',
            message: ''
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('invitation', ['errors'])
    },
    validations,
    methods: {
        ...mapActions('invitation', ['sendInvitation', 'resetErrors']),
        closeModal() {
            this.email = ''
            this.name = ''
            this.message = ''

            this.$v.$reset()

            this.resetErrors()

            this.$emit('closeModal')
        },
        async saveModal() {
            if (this.loading) return
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true
                this.$v.$reset()

                let data = {
                    email: this.email,
                    name: this.name,
                    message: this.message
                }

                await this.sendInvitation(data)

                this.loading = false

                if (Object.keys(this.errors.sendInvitation).length) {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка'
                    })
                } else {
                    this.$notify({
                        type: 'success',
                        text: 'Приглашение отправлено'
                    })
                    this.closeModal()
                }
            } else {
                this.$notify({
                    type: 'error',
                    text: 'Форма заполнена некорректно'
                })
            }
        }
    }
}
</script>
